import { Shield, Award, Globe, Clock } from 'lucide-react';

const trustStats = [
  { icon: Globe, value: '200+', label: 'Campaigns Managed', description: 'Across Meta, Google & LinkedIn' },
  { icon: Award, value: '$47M+', label: 'Revenue Generated', description: 'For our clients in 24 months' },
  { icon: Shield, value: '96%', label: 'Client Retention', description: 'Because results speak louder' },
  { icon: Clock, value: '<48hrs', label: 'Launch Speed', description: 'From strategy to live campaigns' },
];

const logos = [
  'Meta Business Partner',
  'Google Premier Partner',
  'HubSpot Certified',
  'Shopify Plus Partner',
  'Klaviyo Partner',
  'TikTok Marketing',
];

export default function TrustSection() {
  return (
    <section data-testid="trust-section" className="relative py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Partner Logos */}
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-gray-400 uppercase tracking-[0.2em] mb-8">Trusted Technology Partners</p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            {logos.map((name) => (
              <div
                key={name}
                className="flex items-center gap-2 px-5 py-3 rounded-xl bg-gray-50 border border-gray-100 text-gray-500 font-semibold text-sm transition-all duration-300 hover:border-vertex-200 hover:text-vertex-600 hover:bg-vertex-50"
              >
                <div className="w-2 h-2 rounded-full bg-vertex-400" />
                {name}
              </div>
            ))}
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustStats.map((stat, i) => (
            <div
              key={stat.label}
              className="relative group bg-gradient-to-br from-vertex-900 to-vertex-950 rounded-2xl p-6 overflow-hidden card-hover"
            >
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-vertex-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <div className="relative">
                <div className="inline-flex p-3 rounded-xl bg-vertex-500/15 mb-4">
                  <stat.icon className="w-6 h-6 text-vertex-400" />
                </div>
                <div className="text-3xl font-display font-bold text-white mb-1">{stat.value}</div>
                <div className="text-vertex-300 font-semibold text-sm mb-2">{stat.label}</div>
                <div className="text-gray-500 text-xs">{stat.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
